<div class="topbar">
    <div class="topbar-wrapper">
      <div class="topbar-left">
        <a class="topbar-logo" href="#">
          <img src="./assets/activitiesImages/micada_new_logo.png" alt="">
        </a>
  
      </div>
    </div>
  </div>
  